<div (clickOutside)="onClickOutSide()">
  <div class="app-header-bar">
    @if (isActiveSession) {
      <div class="app-menu-toggler">
        <img class="menu-hamburger" [src]="isMenuOpened ? 'assets/imgs/white-x-icon.svg' : 'assets/icons/hamburger.svg'" (click)="toggleMenu()" />
        <span class="vertical-bar">|</span>
      </div>
    }
    <span id="appTitle" class="app-title">SABIS<span class="reg-mark">&reg;</span> {{applicationName}}  <b>{{environment}}</b></span>

    @if (isActiveSession) {
      <div class="right-header-section">
        @if (isRegisteredStudent) {
          <div class="header-btn-container"
            [class.active]="isArchivedBtnActive"
            (click)="viewArchivedBookshelf()">
            <img class="archived-book-icon" [src]="isArchivedBtnActive ? 'assets/icons/Archive-icon-active.svg' : 'assets/icons/Archive-icon.svg'" />
          </div>
        }
        @if (actions.length > 0) {
          <div class="header-btn-container">
            @for (action of actions; track action) {
              <img tappable class="header-action dynamic"
                [src]="action.iconSource"
                (click)="onHeaderActionClicked(action)" />
            }
          </div>
        }
        <div class="header-btn-container app-user-avatar" (click)="toggleUserInfo()">
          <img class="user-avatar-image" src="assets/icons/default-avatar.svg" />
        </div>
      </div>
    }

  </div>

  @if (isMenuOpened) {
    <div class="app-menu-container">
      <app-menu [menuItems]="menuItems" (onItemClick)="isMenuOpened=false"></app-menu>
    </div>
  }
  <div>
    @if (isUserInfoOpened) {
      <div class="app-user-info">
        <app-user-info [user]="user" rightPosition="24.5px"></app-user-info>
      </div>
    }
  </div>
</div>

